import { Box, Grid, IconButton, Paper } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardIcon from '@material-ui/icons/Keyboard';
import Looks3Icon from '@material-ui/icons/Looks3';
import Looks4Icon from '@material-ui/icons/Looks4';
import Looks1Icon from '@material-ui/icons/LooksOne';
import Looks2Icon from '@material-ui/icons/LooksTwo';
import { useIsMobile, useWithSound } from '@timeflies/app-ui';
import React from 'react';
var storageShortcutsHelperKey = 'shortcuts-helper';
var getHasShortcutsHelper = function () {
    var _a;
    var shortcutsHelperRaw = localStorage.getItem(storageShortcutsHelperKey);
    return (_a = (shortcutsHelperRaw && JSON.parse(shortcutsHelperRaw))) !== null && _a !== void 0 ? _a : true;
};
var setHasShortcutsHelper = function (hasHelper) {
    localStorage.setItem(storageShortcutsHelperKey, JSON.stringify(hasHelper));
};
export var KeyboardShortcutsHelper = function () {
    var isMobile = useIsMobile();
    var withSound = useWithSound('buttonClick');
    var _a = React.useReducer(function (prevOpen, nextOpen) {
        setHasShortcutsHelper(nextOpen);
        return nextOpen;
    }, getHasShortcutsHelper()), open = _a[0], setOpen = _a[1];
    var handleClose = function () { return setOpen(false); };
    if (isMobile || !open) {
        return null;
    }
    return (React.createElement(Paper, null,
        React.createElement(Box, { p: 1 },
            React.createElement(Grid, { container: true, alignItems: 'center', justify: 'space-between', wrap: 'nowrap' },
                React.createElement(Grid, { item: true },
                    React.createElement(KeyboardIcon, null)),
                React.createElement(Grid, { item: true }, "keyboard shortcuts"),
                React.createElement(Grid, { item: true },
                    React.createElement(IconButton, { size: 'small', onClick: withSound(handleClose) },
                        React.createElement(CloseIcon, { fontSize: 'inherit' })))),
            React.createElement(Grid, { container: true, justify: 'space-around', wrap: 'nowrap' },
                React.createElement(Grid, { item: true },
                    React.createElement(Looks1Icon, null)),
                React.createElement(Grid, { item: true },
                    React.createElement(Looks2Icon, null)),
                React.createElement(Grid, { item: true },
                    React.createElement(Looks3Icon, null)),
                React.createElement(Grid, { item: true },
                    React.createElement(Looks4Icon, null))))));
};
